export const QA_NAME_CALENDAR_GRID_OUTSIDE_HOURS = 'calendarGridOutsideHours'
